export default __webpack_public_path__ + "static/media/china.265c486b.svg";